import { UploadComponent } from "./uploadImage"

type UploadComponentProps = {
  value?: string,
  onChange?: (value: string) => void,
}

export const UploadComponentAntdCompatibilityWrapper = ({ value, onChange }: UploadComponentProps) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return <UploadComponent image={value ?? ""} setImage={onChange} placeholder="Upload Banner Image" />
}
